import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Link from '@atlaskit/link';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Grid, Inline, Text, xcss } from '@atlaskit/primitives';

import { messages } from './messages';

const containerStyles = xcss({
	wordBreak: 'break-word',
	borderRadius: 'radius.small',
	backgroundColor: 'color.background.information',
	paddingLeft: 'space.150',
	paddingRight: 'space.150',
	paddingTop: 'space.150',
	paddingBottom: 'space.150',
});

const AssetsAppMessageBanner = ({ testId }: { testId?: string }): React.JSX.Element => {
	return (
		<>
			<Grid
				alignItems="center"
				templateAreas={['icon text cta']}
				templateColumns="min-content 1fr auto"
				columnGap="space.150"
				testId={testId}
				xcss={containerStyles}
			>
				<StatusInformationIcon label="information" color="var(--ds-icon-brand)" />
				<Inline space="space.050" alignBlock="center" shouldWrap>
					<Text size="medium">
						<FormattedMessage
							{...messages.assetsAsAnAppBannerText}
							values={{
								assetsSearchLink: (children) => (
									<Link href="/jira/assets?showSearch=true">{children}</Link>
								),
								bold: (children) => <Text weight="bold">{children}</Text>,
							}}
						/>
					</Text>
				</Inline>
			</Grid>
		</>
	);
};

export default AssetsAppMessageBanner;
